import { Editor } from '@tiptap/react'
import { useLayoutEffect } from 'react'

/**
 * Custom hook for TextEditor that toggles the editable
 * state when the readOnly prop changes.
 */
export const useReadOnly = (editor: Editor | null, readOnly: boolean) => {
  // A layout effect, because editable and read-only content have different
  // padding, and the browser must not paint the old state
  useLayoutEffect(() => {
    // readOnly and isEditable are opposites, so check
    // if they're equal to know if we should update
    if (editor && !editor.isDestroyed && readOnly === editor.isEditable) {
      editor.setEditable(!readOnly, false)
    }
  }, [editor, readOnly])
}
